import {
  ChangeDetectionStrategy,
  Component,
  inject,
  forwardRef,
  OnInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicTypeaheadWebBaseComponent } from '../base/dynamic-typeahead.web-base-component';
import { OfficeLocVPService } from '@ups/xplat/api/services';

const SEARCH_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DynamicTypeaheadOfficeComponent),
  multi: true,
};

@Component({
  selector: 'ups-dynamic-typeahead-office',
  templateUrl: 'dynamic-typeahead-office.component.html',
  providers: [SEARCH_CONTROL_VALUE_ACCESSOR],
  // WI 35909 (S1): template state is marked at each async write in the shared typeahead bases
  // (WI 35584); this subclass adds no template-read async writes of its own.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTypeaheadOfficeComponent
  extends DynamicTypeaheadWebBaseComponent
  implements OnInit
{
  private readonly searchOfficeLocVPService = inject(OfficeLocVPService);

  ngOnInit() {
    super.ngOnInit();
    this.searchQuery = this.searchOfficeLocVPService.search.bind(
      this.searchOfficeLocVPService
    );
  }
}
